import api from '@cannect/services/api'

export type TBrandItem = {
  id: number
  uuid: string
  name: string
  status: string
  brandInfos?: {
    id: number
    primaryColor?: string
    secondaryColor?: string
    logo?: string | null
    alternativeLogo?: string | null
    banner_bg_url?: string | null
    banner_title?: string | null
    banner_subtitle?: string | null
    banner_title_color?: string | null
    banner_subtitle_color?: string | null
    description_cols?: string[] | null
  } | null
}

export type TGetBrandsAllResponse = {
  success: boolean
  brands: TBrandItem[]
  total: number
  totalPages: number
  currentPage: number
}

export const getAllActiveBrands = async (limit: number = 6) => {
  return api.get<TGetBrandsAllResponse>(`/brands/active`).then(({ data }) => data)
}
